<template>
  <div
    class="selectedArticleCategory"
    :class="[
      'selectedArticleCategory',
      { 'selectedArticleCategory--disableGrayBackground': data.disableGrayBackground },
    ]"
  >
    <div class="container">
      <div class="selectedArticleCategory__contentWrapper">
        <SectionContainer :title="data.title" :small-title="data.smallTitle">
          <div class="selectedArticleCategory__content">
            <SliderTiles
              slides-per-view="auto"
              content-type="news"
              :items="advices"
              nav-buttons-type="rounded"
            />
          </div>
        </SectionContainer>
      </div>
    </div>
  </div>
</template>

<script>
import SectionContainer from '@/components/SectionContainer.vue';
import SliderTiles from '@/components/Sliders/SliderTiles.vue';

export default {
  name: 'SelectedArticleCategory',
  components: { SliderTiles, SectionContainer },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    advices: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.selectedArticleCategory {
  $root: &;

  &__content {
    padding: 2rem 2rem 3rem 2rem;
  }

  &--disableGrayBackground {
    background-color: $cWhite;
    padding-top: 3rem;
    padding-bottom: 2rem;

    #{$root}__contentWrapper {
      margin: 0 -2rem;
    }

    @include rwd('tablet') {
      padding-top: 2rem;
      padding-bottom: 1rem;
    }
  }
}
</style>
